module.exports = __webpack_public_path__ + "img/ios.41065169.png";